module.exports = __webpack_public_path__ + "static/media/banner_ecommerce01.b76aeb5e.jpg";